export default {"src":"/pro/_next/static/media/blitz-chain-env-switcher-icon.5c41764b.svg","height":17,"width":17,"blurWidth":0,"blurHeight":0};